import * as React from "react";
import "./Footer.css";

import mailIcon from "../../media/icons/mail.svg";
import instagramIcon from "../../media/icons/instagram.svg";
import linkedinIcon from "../../media/icons/linkedin.svg";
import githubIcon from "../../media/icons/github.svg";
import {
  githubUrl,
  instagramUrl,
  linkedInUrl,
  mailUrl,
} from "../../config/links";
import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-gtag";

class Footer extends React.Component {
  render() {
    return (
      <div className="footer w-full md:h-36">
        <div className="footer-content h-full max-w-screen-xl m-auto flex flex-col-reverse md:flex-row pt-2">
          <div className="copyright-block flex flex-col justify-center text-center md:pl-6 md:pt-4 pb-2 md:pb-14 md:text-left md:text-lg">
            <div>© 2022 Nawe Robotics </div>
            <div className="h-8 md:pt-1 dont-highlight-on-touch">
              <OutboundLink href={mailUrl} target="_blank" aria-label="Email">
                <img className="inline-block mr-1" src={mailIcon} alt="email" />{" "}
              </OutboundLink>
              <OutboundLink
                href={instagramUrl}
                target="_blank"
                aria-label="Instagram"
              >
                {" "}
                <img
                  className="inline-block mr-1 ml-1"
                  src={instagramIcon}
                  alt="instagram"
                />
              </OutboundLink>
              <OutboundLink
                href={linkedInUrl}
                target="_blank"
                aria-label="Linkedin"
              >
                <img
                  className="inline-block mr-1 ml-1"
                  src={linkedinIcon}
                  alt="linkedin"
                />
              </OutboundLink>
              <OutboundLink
                href={githubUrl}
                target="_blank"
                aria-label="Github"
              >
                <img
                  className="inline-block mr-1 ml-1"
                  src={githubIcon}
                  alt="github"
                />
              </OutboundLink>
            </div>
          </div>
          <div className="links-block flex flex-col sm:flex-row justify-center sm:flex-grow md:p-3 mt-1 text-center md:justify-end md:text-lg">
            <div className="sm:w-36">
              <div>
                <Link to="/">Home</Link>
              </div>
              <div>
                <Link to="/#capabilities">Capabilities</Link>
              </div>
            </div>
            <div className="sm:w-36">
              <div>
                <Link to="/products/">Products</Link>
              </div>
              <div>
                <Link to="/products/#actuators">Actuators</Link>
              </div>
              <div>
                <Link to="/products/#encoders">Encoders</Link>
              </div>
            </div>
            <div className="sm:w-36">
              <div>
                <Link to="/contactus/">Contact Us</Link>
              </div>
              <div>
              <a href="https://www.iubenda.com/privacy-policy/12182492">Privacy Policy</a>
              </div>
              <div>
              <a href="https://www.iubenda.com/privacy-policy/12182492/cookie-policy">Cookie Policy</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
